angular.module('app').component('adminNumberInput', {
    templateUrl: 'events/components/number-input.html',
    transclude: true,
    bindings: {
        label: '@',
        hideLabel: '<?'
    },
    controller: ['$element', function($element) {
        var main = this;

        main.step = function(amount) {
            var input = $element[0].querySelector('input[type="number"]');
            if (!input) {
                return;
            }

            var value = parseFloat(input.value);
            input.value = (isNaN(value) ? 0 : value) + amount;
            angular.element(input).triggerHandler('input');
        };
    }]
});
